<template>
    <div
        v-if="praiseList && praiseList.length >= 3"
        class="reputation"
        data-type="anchor"
        data-anchor="reputation"
    >
        <h3 class="title">
            <p class="title-h3">车主口碑</p>
            <router-link
                class="title-more"
                :to="{
                    name: 'USER_COMMENT',
                    query: {
                        seriesName
                    },
                    params: {
                        serid: seriesId
                    }
                }"
                target="_blank"
                @click.native="handleLog('watchMore')"
            >
                查看更多
                <i class="el-icon-arrow-right"></i>
            </router-link>
        </h3>
        <div class="content">
            <router-link
                class="comment-title"
                :to="{
                    name: 'USER_COMMENT',
                    query: {
                        seriesName
                    },
                    params: {
                        serid: seriesId
                    }
                }"
                target="_blank"
                @click.native="handleLog('stars')"
            >
                <div class="comment-marks">{{praiseInfo.average}}</div>
                <div class="comment-stars">
                    <template v-if="praiseInfo.average !== '暂无评分'">
                        <c-stars :fullStars="praiseInfo.average"/>
                    </template>
                    <p class="comment-nums">{{praiseInfo.num}}</p>
                </div>
                <div class="comment-tags">
                    <template v-for="(item, idx) in (tagList.advantage || [])">
                        <p v-if="idx <= 2">{{item.tag_org}}</p>
                    </template>
                </div>
            </router-link>
            <div class="comment-info">
                <template v-for="(item, index) in praiseList">
                    <div class="comment-item" :key="item.loc" @click="handleCommentClick(index)">
                        <h4 :title="item.model_name">{{item.model_name}}</h4>
                        <div class="user-info">
                            <div class="user-avatar">
                                <img
                                    src="@/common/images/user-comment/avatar-default.png"
                                    v-real-src="item.avatar"
                                />
                            </div>
                            <p>{{item.nickname}}</p>
                        </div>
                        <div class="user-comment">
                            <div class="car-info">
                                <div class="info-item">
                                    <p class="info-item-up">{{item.purchase_price}}</p>
                                    <p class="info-item-down">
                                        <img src="@/common/images/car-train/price.svg">
                                        <span>裸车购买价</span>
                                    </p>
                                </div>
                                <div class="info-item">
                                    <p class="info-item-up">{{item.purchase_city_name}}</p>
                                    <p class="info-item-down">
                                        <img src="@/common/images/car-train/location.svg">
                                        <span>购买地点</span>
                                    </p>
                                </div>
                                <div class="info-item">
                                    <p class="info-item-up">{{item.mileage || '暂无'}}</p>
                                    <p class="info-item-down">
                                        <img src="@/common/images/car-train/mail.svg">
                                        <span>里程</span>
                                    </p>
                                </div>
                            </div>
                            <div class="car-comment">
                                <template v-if="item.content">
                                    <div
                                        v-for="(comment, idx) in item.content"
                                        class="car-comment-item"
                                    >
                                        <p class="comment-item-left">{{comment.name}}</p>
                                        <p class="comment-item-right c-line-clamp2">{{comment.value}}</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file 口碑组件
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {sendLog} from 'js/log';
import {openUrlInNewTab} from 'js/core';
import Stars from '../../components/stars';

export default {
    components: {
        'c-stars': Stars
    },
    props: {
        seriesId: String,
        seriesName: String
    },
    data() {
        return {
            praiseInfo: {},
            tagList: {},
            praiseList: []
        };
    },
    watch: {
        seriesId(val) {
            if (val) {
                this.getData(val);
            }
        }
    },
    mounted() {

    },
    methods: {
        getData(seriesId) {
            /* eslint-disable fecs-camelcase */
            request(URLS.GETPRAISELIST, {
                series_id: seriesId,
                pn: 0,
                rn: 3
            })
                .then(res => {
                    const {praise_info, tag_list, praise_list} = res.Result;
                    this.praiseInfo = praise_info;
                    this.tagList = tag_list;
                    this.praiseList = praise_list;

                    // 通知外层加载状态
                    this.$emit('getdatastatus', 'reputation', praise_list.length >= 3);
                })
                .catch(err => {
                    this.$emit('getdatastatus', 'reputation', false);
                    // console.log(err);
                });
            /* eslint-enable fecs-camelcase */
        },
        handleCommentClick(index) {
            openUrlInNewTab({
                name: 'USER_COMMENT',
                query: {
                    seriesName: this.seriesName,
                    index
                },
                params: {
                    serid: this.seriesId
                }
            });
            this.sendLog('comment_info', {
                pos: index
            });
        },
        handleLog(type) {
            if (type === 'watchMore') {
                this.sendLog('comment_more');
            }
            else if (type === 'stars') {
                this.sendLog('stars_click');
            }
        },
        sendLog(key, params) {
            sendLog(`car_train_${key}`, {
                seriesId: this.seriesId,
                seriesName: this.seriesName,
                ...(params || {})
            });
        }
    }
};
</script>

<style lang="less" scoped>
.reputation {
    // overflow: hidden;
}
.title {
    overflow: hidden;
    line-height: 1;
    .title-h3 {
        float: left;
    }
    .title-more {
        float: right;
        font-size: 16px;
        color: #666666;
        font-weight: 400;
    }
}
.content {
    padding-top: 15px;
    border-top: 1px solid #EEEEEE;
    .comment-title {
        display: flex;
        align-items: center;
        .comment-marks {
            font-family: PingFangSC-Semibold;
            font-size: 42px;
            letter-spacing: .66px;
            color: #333333;
        }
        .comment-stars {
            margin-left: 10px;
            .comment-nums {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                line-height: 14px;
                color: #333333;
            }
        }
        .comment-tags {
            display: flex;
            margin-left: 40px;
            p {
                height: 30px;
                margin-right: 10px;
                line-height: 32px;
                padding: 0 12px;
                font-size: 14px;
                border-radius: 4px;
                color: #999999;
                background: #F6F6F6;
            }
        }
    }
    .comment-info {
        display: flex;
        margin-top: 22px;
    }
    .comment-item {
        width: 385px;
        margin-left: 22px;
        cursor: pointer;
        &:first-child {
            margin-left: 0;
        }
        h4 {
            font-size: 20px;
            line-height: 20px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .user-info {
            display: flex;
            align-items: center;
            margin-top: 10px;
            .user-avatar {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                overflow: hidden;
                background: #efefef;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            p {
                margin-left: 14px;
                font-size: 14px;
                line-height: 14px;
                color: #999999;
            }
        }
    }
    .user-comment {
        position: relative;
        height: 196px;
        padding: 25px 15px 20px;
        margin-top: 16px;
        background: #FAFAFA;
        border: 1px solid #F1F1F1;
        &::before {
            content: '';
            position: absolute;
            top: -5px;
            left: 5px;
            width: 8px;
            height: 8px;
            background: #FAFAFA;
            border-width: 1px 0 0 1px;
            border-style: solid;
            transform: rotateZ(45deg);
            color: #F1F1F1;
        }
        .car-info {
            display: flex;
            .info-item {
                margin-right: 23px;
            }
            .info-item-up {
                font-size: 18px;
                line-height: 18px;
                color: #333333;
            }
            .info-item-down {
                display: flex;
                align-items: center;
                margin-top: 5px;
                font-size: 14px;
                height: 14px;
                color: #999999;
                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 3px;
                }
            }
        }
        .car-comment {
            margin-top: 18px;
        }
        .car-comment-item {
            display: flex;
            overflow: hidden;
            font-size: 14px;
            margin-bottom: 7px;
            &:last-child {
                margin-bottom: 0;
            }
            .comment-item-left {
                width: 60px;
                line-height: 24px;
                font-weight: 500;
                color: #333333;
            }
            .comment-item-right {
                flex: 1;
            }
        }
    }
}
</style>
